import { CodeArticleWithCid, PublicationSheetWithId } from '@livv/models';
import { stripHtmlTags } from '@utils/parsing';
import { truncateText } from '@utils/string';

interface PreviewProps {
    docId: string;
    title: string;
    snippet: string;
}

const SNIPPET_LENGTH = 250;

const isPublicationSheet = (content: CodeArticleWithCid | PublicationSheetWithId): boolean =>
    Object.keys(content).includes('number');

const getPreviewProps = (content: CodeArticleWithCid | PublicationSheetWithId): PreviewProps => {
    if (isPublicationSheet(content)) {
        const {
            content: publicationSheetContent,
            id,
            number,
            title,
        } = content as PublicationSheetWithId;

        return {
            docId: id,
            snippet: truncateText(
                publicationSheetContent.blocks.map(({ text }) => text).join('\n'),
                SNIPPET_LENGTH,
            ),
            title: `${number}. ${title}`,
        };
    }

    const { cid, title, versions } = content as CodeArticleWithCid;

    return {
        docId: cid,
        snippet: truncateText(stripHtmlTags(versions[0].texteHtml), SNIPPET_LENGTH),
        title,
    };
};

export default getPreviewProps;
